<template>
    <main  role="main">

        <div class="mx-auto max-w-7xl">

            <div class="">
                <div class="flex h-full min-h-screen">

                    <div class="flex flex-col flex-1 min-w-0 overflow-visible sm:px-6 lg:px-8">
                        <div class="relative z-0 flex flex-1 mb-12 overflow-visible bg-white">
                            <div class="relative z-0 flex-1 pt-6 overflow-y-auto focus:outline-hidden xl:order-last">

                                <div class="relative inset-0 px-4 pb-6 sm:px-6 lg:px-8">
                                    <div class="h-full rounded-lg">
                                        <div class="pt-5 pl-4 pr-4 contentful-tab">
                                            <div class="guidesTab md:h-full">

                                                <section>
                                                    <div v-if="submitSuccessful"
                                                         class="min-h-full px-4 py-16 bg-white sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">

                                                        <div class="min-w-full mx-auto text-center">
                                                            <main class="">
                                                                <div class="space-y-3 ">
                                                                    <h1 class="text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
                                                                        Thank you!</h1>
                                                                    <h2 class="text-lg font-medium text-center text-clay-950">
                                                                        We have received your company submission. We
                                                                        will send you an e-mail confirmation once your
                                                                        company page has been added to StageAgent.</h2>
                                                                </div>

                                                                <div class="flex justify-center mt-10 space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                                                                    <a class="inline-flex items-center px-5 py-3 font-medium text-white uppercase border border-transparent rounded-md shadow-sm t bg-rose-500 hover:bg-rose-600 focus:outline-hidden focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
                                                                       href="/theatre-companies">
                                                                        Browse Company Pages</a>
                                                                </div>
                                                            </main>
                                                        </div>

                                                    </div>
                                                    <form v-else>
                                                        <h1 class="mt-6 mb-3 text-2xl font-bold tracking-tight font-display text-clay-950">
                                                            Add a Company</h1>
                                                        <ErrorSummary :response-status="responseStatus"/>
                                                        <div class="grid grid-cols-4 gap-6 mt-6">
                                                            <div class="col-span-4">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="name">Company
                                                                    Name</label>
                                                                <input id="name"
                                                                       v-model="company.name"
                                                                       class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                                                       name="name"
                                                                       placeholder="e.g. Awesome Company"
                                                                       type="text">
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="location">Primary
                                                                    Location</label>
                                                                <VueGoogleAutocomplete
                                                                        id="location"
                                                                        ref="formattedAddress" classname="mt-1 block w-full border border-clay-500 rounded-md shadow-sm py-2 px-3 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                                                        name="location"
                                                                        placeholder="Start typing. e.g. New York City, USA"
                                                                        types=""
                                                                        v-on:placechanged="getLocationData"/>

                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="webUrl">Website
                                                                    URL</label>
                                                                <input id="webUrl" v-model="company.webUrl"
                                                                       class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm" name="webUrl"
                                                                       placeholder="e.g. https://stageagent.com"
                                                                       type="text">
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700 "
                                                                       for="phone">Phone</label>
                                                                <input id="phone" v-model="company.phone" class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                                                       name="phone"
                                                                       placeholder="e.g. 2145541234"
                                                                       type="text">
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700 "
                                                                       for="email">Email</label>
                                                                <input id="email" v-model="company.email" class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                                                       name="email"
                                                                       placeholder="e.g. info@stageagent.com"
                                                                       type="text">
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="facebook">Facebook</label>
                                                                <div class="flex mt-1 rounded-md shadow-sm">
                                                                    <span
                                                                            class="inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm">
                                                                            <svg fill="currentColor" class="shrink-0 w-4 h-4 text-inherit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                              <path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"/>
                                                                            </svg>
                                                                    </span>
                                                                    <input id="facebook" v-model="company.facebook"
                                                                           class="flex-1 block w-full min-w-0 border-clay-500 rounded-none focus:ring-electric-500 focus:border-electric-500 rounded-r-md sm:text-sm" name="facebook"
                                                                           placeholder="e.g. https://facebook.com/stageagentcom"
                                                                           type="text">
                                                                </div>
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="twitter">Twitter</label>
                                                                <div class="flex mt-1 rounded-md shadow-sm">
                                                                    <span
                                                                            class="inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm">
                                                                            <svg fill="currentColor" class="shrink-0 w-4 h-4 text-inherit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                                <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                                                                            </svg>
                                                                            </span>
                                                                    <input id="twitter" v-model="company.twitter"
                                                                           class="flex-1 block w-full min-w-0 border-clay-500 rounded-none focus:ring-electric-500 focus:border-electric-500 rounded-r-md sm:text-sm" name="x"
                                                                           placeholder="e.g. https://x.com/stageagent"
                                                                           type="text">
                                                                </div>
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="in">Instagram</label>
                                                                <div class="flex mt-1 rounded-md shadow-sm">
                                                                    <span
                                                                            class="inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm">
                                                                        <svg fill="currentColor" class="shrink-0 w-4 h-4 text-inherit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                                                                        </svg>        
                                                                    </span>
                                                                    <input id="in" v-model="company.instagram"
                                                                           class="flex-1 block w-full min-w-0 border-clay-500 rounded-none focus:ring-electric-500 focus:border-electric-500 rounded-r-md sm:text-sm" name="in"
                                                                           placeholder="e.g. https://instagram.com/stageagentcom"
                                                                           type="text">
                                                                </div>
                                                            </div>

                                                            <div class="col-span-4 md:col-span-2">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="youtube">Youtube</label>
                                                                <div class="flex mt-1 rounded-md shadow-sm">
                                                                    <span
                                                                        class="inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm">
                                                                        <svg fill="currentColor" class="shrink-0 w-5 h-5 text-inherit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                                                            <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/>
                                                                        </svg>
                                                                    </span>
                                                                    <input id="youtube" v-model="company.youtube"
                                                                           class="flex-1 block w-full min-w-0 border-clay-500 rounded-none focus:ring-electric-500 focus:border-electric-500 rounded-r-md sm:text-sm" name="youtube"
                                                                           placeholder="e.g. https://youtube.com/stageagentcom"
                                                                           type="text">
                                                                </div>
                                                            </div>

                                                            <div class="col-span-4">
                                                                <label class="block text-sm font-medium text-gray-700"
                                                                       for="about">About
                                                                    Us <small>(Max. 5000 characters)</small></label>
                                                                <div class="mt-1">
                                                                    <md-editor id="about"
                                                                               v-model="company.about"
                                                                               :toolbars="['bold', 'italic', 'underline']"
                                                                               :footers="[]"
                                                                               class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-clay-900 outline-1 -outline-offset-1 outline-clay-300 placeholder:text-clay-900 focus:outline-2 focus:-outline-offset-2 focus:outline-clay-600 sm:text-sm/6"
                                                                               language="en-US"
                                                                               name="about"/>
                                                                </div>
                                                            </div>

                                                            <div class="col-span-4">
                                                                <div class="max-w-full px-6 py-3 my-4 text-base tracking-tight divide-y divide-slate-300/30 rounded-2xl sm:py-7 sm:px-8 prose-slate bg-clay-50">
                                                                    <h2 class="max-w-2xl font-bold text-gray-700">
                                                                        Keywords (select up to 6)</h2>
                                                                    <div class="mt-6">
                                                                        <dl class="">
                                                                            <dd>
                                                                                <fieldset class="space-y-5">
                                                                                    <legend class="sr-only">Keyword
                                                                                        select
                                                                                    </legend>
                                                                                    <div class="grid grid-cols-1 space-y-3 sm:grid-cols-2 lg:grid-cols-3 lg:space-y-1">
                                                                                        <div v-for="option in keywordOptions"
                                                                                             class="relative flex items-start">
                                                                                            <div class="flex items-center h-5">
                                                                                                <input :id="option"
                                                                                                       v-model="company.keywords"
                                                                                                       :name="option"
                                                                                                       :value="option"
                                                                                                       aria-describedby=""
                                                                                                       class="w-4 h-4 text-electric-600 border-clay-500 rounded focus:ring-electric-500"
                                                                                                       type="checkbox">
                                                                                            </div>
                                                                                            <div class="ml-3 text-sm">
                                                                                                <label :for="option"
                                                                                                       class="font-medium text-gray-700">{{
                                                                                                        option
                                                                                                    }}</label>
                                                                                                <span class="text-clay-800"></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </fieldset>
                                                                            </dd>
                                                                        </dl>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                          <div class="col-span-4">
                                                            <dl class="divide-y divide-gray-200">
                                                              <div class="grid grid-cols-1 sm:grid-cols-4 gap-6 mt-2 sm:mt-6">
                                                                <div class="sm:col-span-4">
                                                                  <label class="block text-sm font-medium text-gray-700">Company Logo</label>
                                                                  <div class="flex flex-col items-center justify-center px-4 sm:px-6 pt-4 pb-4 sm:pb-6 mt-1 border-2 border-clay-500 border-dashed rounded-md w-full">
                                                                    <div v-if="company.image && company.image.length > 0" class="w-full max-w-xs sm:max-w-sm">
                                                                      <div class="overflow-hidden bg-gray-100 border rounded-lg shadow-lg aspect-square border-slate-900">
                                                                        <img :src="company.image" class="object-cover object-center w-full">
                                                                      </div>
                                                                      <button class="relative flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-900 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 mt-2"
                                                                              type="button" @click.prevent="removeLogo">
                                                                        <TrashIcon class="w-5 h-5 text-red-300 hover:text-red-500"/>
                                                                      </button>
                                                                    </div>
                                                                    <div v-else class="space-y-2 text-center w-full">
                                                                      <uc-config style="display: none" pubkey="c1ecae68d0087aa3986a" ctx-name="my-uploader"
                                                                                 img-only="true" multiple="false" :max-local-file-size-bytes="UploadCareSettings.maxLocalFileSizeBytes"
                                                                                 crop-preset="1:1" image-shrink="400x400" confirm-upload="true" remove-copyright="true"
                                                                                 :source-list="UploadCareSettings.sourceList">
                                                                      </uc-config>
                                                                      <uc-upload-ctx-provider id="uploaderctx" ctx-name="my-uploader" @done-click="handleDoneEvent">
                                                                      </uc-upload-ctx-provider>
                                                                      <uc-file-uploader-regular ctx-name="my-uploader" class="uc-light w-full">
                                                                        <p class="text-xs text-clay-800">PNG, JPG, GIF up to 4MB</p>
                                                                      </uc-file-uploader-regular>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </dl>
                                                          </div>
                                                        </div>

                                                        <div class="py-3 mt-10 text-center">
                                                            <SaButton @click.prevent="submit" :loading="isSubmitting" variant="primary">
                                                                <template #loading>
                                                                    <span class="font-semibold">Processing...</span>
                                                                </template>
                                                                <span class="font-semibold">Add Company</span>
                                                            </SaButton>
                                                        </div>


                                                    </form>
                                                </section>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>


</template>

<script lang="ts" setup>
import {onMounted, Ref, ref} from "vue";
import {client, UploadCareSettings} from '@/shared';
import _ from 'lodash';
import { Location, SubmitCompany} from "@/dtos";
// @ts-ignore
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {ResponseStatus} from "@servicestack/client";
import {TrashIcon} from '@heroicons/vue/20/solid';
import ErrorSummary from "@/main/components/ErrorSummary.vue";

import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';

import * as UC from '@uploadcare/file-uploader';
import "@uploadcare/file-uploader/web/uc-file-uploader-inline.min.css"
import SaButton from "@/main/components/SaButton.vue";

UC.defineComponents(UC);

let responseStatus = ref(null);
let company: Ref<SubmitCompany> = ref(new SubmitCompany({
    keywords: []
}));
let submitSuccessful: Ref<Boolean> = ref(false);
let keywordOptions = [
    "Children's Theatre",
    "Classes",
    "Classical",
    "Community Theatre",
    "Contemporary Plays",
    "Dance",
    "Equity",
    "Equity Member Candidate (EMC)",
    "Festival",
    "Film",
    "Fringe",
    "Instrumental",
    "LORT",
    "Modeling",
    "Musicals",
    "New Works",
    "Non-union",
    "Opera",
    "Other",
    "School",
    "Television",
    "Touring",
    "Union",
    "Venue",
    "Web"
];

onMounted(() => {
    const previewWrapper = document.getElementById('md-editor-v3-preview-wrapper');
    if (previewWrapper) {
        previewWrapper.classList.add('hidden', 'sm:block');
    }
});

const isSubmitting = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    submitSuccessful.value = false;

    await client.post<ResponseStatus>(new SubmitCompany(company.value))
        .then(response => {
            submitSuccessful.value = true;
            responseStatus.value = null;
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                left:0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};

const removeLogo = async () => {
    company.value.image = "";
}

const handleDoneEvent = async (e: any) => {
    if (e.detail && e.detail.status === "success") {
        const file = e.detail.successEntries[0];
        await onUploadSuccess(file);
        const uploaderCtx = document.querySelector('#uploaderctx')
        const api = uploaderCtx?.getAPI();
        api.removeAllFiles();
    }
}

const onUploadSuccess = async (response: any) => {
    company.value.image = response.cdnUrl;
}

const getLocationData = async (addressData: any, placeResultData: any, id: any) => {
    let location = new Location();
    location.lat = placeResultData.geometry ? placeResultData.geometry.location.lat() : "";
    location.lng = placeResultData.geometry ? placeResultData.geometry.location.lng() : "";
    location.formattedAddress = placeResultData.formatted_address;
    location.placeId = placeResultData.place_id;
    location.streetNumber = _.result(
        _.find(placeResultData.address_components, {'types': ['street_number']}),
        'short_name');
    location.route = _.result(_.find(placeResultData.address_components, {'types': ['route']}),
        'short_name');
    location.locality = _.result(_.find(placeResultData.address_components, {'types': ['locality']}),
        'short_name');
    location.administrativeAreaLevel1 = _.result(_.find(placeResultData.address_components,
            {'types': ['administrative_area_level_1']}),
        'short_name');
    location.postalCode = _.result(_.find(placeResultData.address_components, {'types': ['postal_code']}),
        'short_name');
    location.country = _.result(_.find(placeResultData.address_components, {'types': ['country']}),
        'short_name');

    company.value.location = location;
}
</script>
<style>

</style>